import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TBulkTerminatePaycardsRequestSchema,
  TBulkTerminatePaycardsResponseSchema,
} from "./bulkTerminatePaycards.schema";

export const bulkTerminatePaycards = (axios: IAxiosInstance) => {
  return async (body: TBulkTerminatePaycardsRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TBulkTerminatePaycardsResponseSchema>
    >(`/api/internal/bulk-terminate-paycards`, body);

    return response.data;
  };
};
